import { CSSProperties } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@ets/design-system';
import { Switch as BaseSwitch, type SwitchProps as BaseSwitchProps } from '@ets/design-system';

export type SwitchProps = Pick<
  BaseSwitchProps,
  'onChange' | 'disabled' | 'value' | 'testId' | 'label'
> & {
  margin?: CSSProperties['margin'];
  inAppActive?: boolean;
};

export const Switch = ({ margin, inAppActive, ...props }: SwitchProps) => {
  const intl = useIntl();

  return (
    <Tooltip
      visible={!!props.disabled}
      placement="top"
      content={
        inAppActive === false
          ? intl.formatMessage({
              id: 'CANNOT_ACTIVATE_EMAIL_NOTIFICATIONS_WITHOUT_THE_ACTIVATION_OF_IN_APP_NOTIFICATIONS',
            })
          : intl.formatMessage({ id: 'SETTING_CANNOT_BE_CHANGED_DUE_TO_SECURITY_ISSUES' })
      }
      testId={props.testId}
    >
      <div>
        <BaseSwitch size="xs" labelPlacement="right" style={{ margin }} {...props} />
      </div>
    </Tooltip>
  );
};
